import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import { GlobalModals } from '../../constants/AppConstants';
import ModalActions from '../../actions/ModalActions';
import { translate as t } from '../../lib/I18n';

import NREHeader from './Header';
import Failure from './Failure';
import Success from './Success';

function NRETransferModal ({ success }) {

    const close = () => ModalActions.close(GlobalModals.NRE);
    const modalProps = {
        onHide: close,
        dialogClassName: 'modal--med',
        animation: false,
        show: true
    };

    return (
        <Modal { ...modalProps } className="modal--transfer">
            <Modal.Body>
                <div className="text-center">
                    <NREHeader />
                    { success ? <Success /> : <Failure /> }
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="default"
                        onClick={ close }
                        className="close btn-lg">
                    { t('button.text.continue') }
                </Button>
            </Modal.Footer>
        </Modal>
    );

}

NRETransferModal.propTypes = {
    success: PropTypes.bool
};

NRETransferModal.defaultProps = {
    success: false
};

export default NRETransferModal;



// WEBPACK FOOTER //
// ./src/components/nre/TransferModal.js